import { z } from 'zod';
import { Role } from './roles.js';
/**
 * Announcements (docs/17-announcements.md): leadership or the administrator writes a message
 * once and every person in the chosen audience gets it in the app, and optionally by e-mail.
 */
/**
 * Who receives it: active accounts, optionally narrowed to some roles and/or one county,
 * minus the people the sender unticked in the list of recipients.
 */
export const announcementAudienceSchema = z.object({
    /** Empty means every role. */
    roles: z.array(z.enum(Role)).max(4).default([]),
    /** Accounts assigned to this county; omitted means the whole country. */
    countyId: z.string().uuid().nullish(),
    /** People left out by hand. Ids outside the audience are simply ignored. */
    excludedUserIds: z.array(z.string().uuid()).max(5000).default([]),
});
/** POST /announcements/audience/people: one page of the audience (before exclusions), by name. */
export const announcementAudiencePeopleSchema = announcementAudienceSchema
    .pick({ roles: true, countyId: true })
    .extend({
    /** Name search; accents optional, like tagging. */
    q: z.string().trim().max(100).default(''),
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(100).default(25),
});
export const announcementCreateSchema = z.object({
    title: z.string().trim().min(3, 'Titulli duhet të ketë të paktën 3 shkronja.').max(200),
    /** HTML from the rich-text editor. Sanitised server-side with the activity allow-list. */
    contentHtml: z.string().max(200_000),
    audience: announcementAudienceSchema,
    /** Also send it by e-mail to everyone in the audience. In the app it is always shown. */
    sendEmail: z.boolean().default(false),
});
/** POST /announcements/preview: the e-mail as the sender would receive it. */
export const announcementPreviewSchema = announcementCreateSchema.pick({
    title: true,
    contentHtml: true,
});
//# sourceMappingURL=announcement.js.map